import { api } from '@/common/api';
import localReferences from '@/helpers/localReferences';

const store = {
    namespaced: true,
    state() {
        return {
            offices: [],
            positions: [],
            sections: [],
            roles: [],
            positionMap: {},
            taskStatuses: [],
            employers: [],
            employersWithRoleLeadByOffice: [],
            companies: [],
            links: [],
            tags: [],
            dealStatuses: [],
            measurers: [],
            installers: [],
            payTypes: [],
            payTypesCategories: [],
            cashTypes: [],
            leadStatuses: [],
            leadLinks: [],
            factories: [],
            profileTypes: [],
            conclusions: [],
            guilty: [],
            garbageRemovals: [],
            events: [],
            measurementTimes: [],
            complaintPerformer: [],
            timesheetStatuses: [],
            messageStatuses: [],
            contractors: [],
            cashes: [],
            operationStatuses: [],
            incomeDetails: [],
            reasonsRefuse: []
        };
    },

    mutations: {
        setRoles(state, data) {
            state.roles = data;
        },
        setReference(state, { data }) {
            state.offices = data.data.offices || [];
            state.positions = data.data.positions || [];
            state.roles = data.data.roles || {};
            state.positionMap = data.data.positionMap || {};
            state.taskStatuses = data.data.taskStatuses || [];
            state.employers = data.data.employers || [];
            state.employersWithRoleLeadByOffice = data.data.employersWithRoleLeadByOffice || [];
            state.cashes = data.data.cashes || [];
            state.companies = data.data.companies || [];
            state.links = data.data.links || [];
            state.tags = data.data.tags || [];
            state.dealStatuses = data.data.dealStatuses || [];
            state.measurers = data.data.employers ? data.data.employers.filter(employer => employer.position_id === localReferences.employerPositions.measurer) : [];
            state.installers = data.data.employers ? data.data.employers.filter(employer => employer.position_id === localReferences.employerPositions.installer) : [];
            state.services = data.data.employers ? data.data.employers.filter(employer => employer.position_id === localReferences.employerPositions.serviceSpecialist || employer.position_id === localReferences.employerPositions.headOfService) : [];
            state.payTypes = data.data.payTypes || [];
            state.payTypesCategories = data.data.payTypesCategories || [];
            state.cashTypes = data.data.cashTypes || [];
            state.operationStatuses = data.data.operationStatuses || [];
            state.leadStatuses = data.data.leadStatuses || [];
            state.leadLinks = data.data.leadLinks || [];
            state.factories = data.data.factories || [];
            state.conclusions = data.data.conclusions || [];
            state.profileTypes = data.data.profileTypes || [];
            state.guilty = data.data.guilty || [];
            state.garbageRemovals = data.data.garbageRemovals || [];
            state.complaintPerformer = data.data.complaintPerformer || [];
            state.measurementTimes = data.data.measurementTimes || [];
            state.timesheetStatuses = data.data.timesheetStatuses || [];
            state.messageStatuses = data.data.messageStatuses || [];
            state.contractors = data.data.contractors || [];
            state.events = data.data.events || [];
            state.reasonsRefuse = data.data.reasonsRefuse || [];
            state.incomeDetails = data.data.incomeDetails || [];
            if (data.data.sections) {
                Object.keys(data.data.sections).forEach(section => state.sections.push({ id: section, name: data.data.sections[section] }));
            }
        },
        setReferenceByName(state, { name, data }) {
            state[name] = data;
        }
    },
    actions: {
        async loadReferences({ state, commit }) {
            try {
                commit('setReference', await api.get('/reference/'));
            } catch (e) {
                throw new Error(e);
            }
        },
        async loadReferenceByName({ state, commit }, name) {
            try {
                const response = await api.get(`/reference/${name}`);
                commit('setReferenceByName', { name: name, data: response.data.data });
            } catch (e) {
                throw new Error(e);
            }
        }
    },
    getters: {
        rolesBySectionDeal: state => state.roles.length
            ? state.roles.filter(item => item.title === 'CRM')[0].children.filter(item => item.title === 'Сделки')[0].children.map(item => item.key)
            : [],
        rolesBySectionLead: state => state.roles.length
            ? state.roles.filter(item => item.title === 'CRM')[0].children.filter(item => item.title === 'Лиды')[0].children.map(item => item.key)
            : [],
        rolesBySectionContacts: state => state.roles.length
            ? state.roles.filter(item => item.title === 'CRM')[0].children.filter(item => item.title === 'Компании')[0].children.map(item => item.key)
            : [],
        rolesBySectionCompanies: state => state.roles.length
            ? state.roles.filter(item => item.title === 'CRM')[0].children.filter(item => item.title === 'Компании')[0].children.map(item => item.key)
            : [],
        rolesBySectionTask: state => state.roles.length
            ? state.roles.filter(item => item.title === 'Задачи')[0].children[0].children.map(item => item.key)
            : [],
        rolesBySectionLeadByOffices(state) {
            return console.log(state.roles.filter(item => item.title === 'CRM')[0].children.filter(item => item.title === 'Лиды')[0].children.map(item => item.key));
        },
        getOfficeNameById(state) {
            return state.offices;
        }
    }
};

export default store;
